import { Button } from '../../../cdl/Button/Button';
import { translate } from '../../../common/helpers/translate.helper';
import { IconDownload } from '../../../common/icons/cdl/Download';
import { useVesselListExportDownload } from '../useVesselListExportDownload';

export const ExportAllVesselsButton = () => {
    const exportVesselList = useVesselListExportDownload();

    return (
        <Button onClick={exportVesselList} LeadingIcon={IconDownload}>
            {translate('vessel.exportAll.button')}
        </Button>
    );
};
